import ModalDemo from './ModalDemo';
// import portada from '../img/portada.png';
import portada_video from '../img/portada_video.mp4';


export default function Home () {

    return(
        <div className="w-full h-[50%] flex flex-col-reverse md:flex-row sm:h-full md:h-full bg-[#f1f2f5] md:pt-10">
            <div className="w-[95%] h-full md:w-[65%] md:h-full flex flex-col justify-center md:pt-6 mb-20">
                <h2 className="text-[6.5vw] sm:text-[5.5vw] md:text-[4.7vw] xl:text-[3.8vw] w-[95%] md:w-[99%] font-semibold text-[#000] pl-10 md:pl-[5rem]">Digitaliza tu empresa</h2>
                <h2 className="text-[6.5vw] sm:text-[5.5vw] md:text-[4.7vw] xl:text-[3.8vw] w-[100%] font-semibold text-[#000] pl-10 md:pl-[5rem]">de paquetería y mensajería</h2>
                <div className='flex w-[22%] h-1 ml-[2.5rem] md:ml-[5rem] mt-4 lg:mt-12 bg-[#ea1300]'></div>
                <div className='flex flex-col ml-[2.5rem] md:ml-[5rem] mt-4 lg:mt-12 mb-2 md:mb-0'>
                    <p className='text-[2.8vw] sm:text-[1.8vw] lg:text-[1.2vw] text-[#5e5e5e] font-semibold '>
                        Reduce costos, optimiza rutas y controla cada envío en 
                        tiempo real. Crea guías, asigna rutas y asegura la entrega final,
                        todo en una sola plataforma.
                    </p>
                </div>
                <div className="flex justify-start ml-[2.5rem] md:ml-[5rem] mt-3 md:mt-10 lg:mt-14">
                    <ModalDemo />
                </div>
            </div>
            <div className='flex align-top md:items-center justify-center md:h-full mb-12'>
                <video 
                    src={portada_video} 
                    autoPlay 
                    loop 
                    muted 
                    className='max-h-[85vh] md:max-h-[100vh] h-full md:w-[95vh]'
                />
            </div>
        </div>
    )
}